import React, {useMemo} from 'react';
import {useFormikContext} from "formik";
import {FormattedMessage, useIntl} from "react-intl";

import StyledReactSelect from "components/select/StyledReactSelect";
import SelectTitle from "components/radioGroup/SelectTitle";

import {getCountryOptions} from "utils/countries";

function CountryOfOriginField(props) {
    const {values, setFieldValue} = useFormikContext();
    const {locale} = useIntl();

    const countryOptions = useMemo(() => getCountryOptions(locale), [locale]);

    function onChange(selectedOption) {
        setFieldValue('countryOfOrigin', selectedOption ? selectedOption.value : null);
    }

    const selectedOption = countryOptions.find((option) => option.value === values.countryOfOrigin) ?? null;

    return (
        <>
            <SelectTitle
                titleTranslationKey='product.show.product.form.field.countryOfOrigin'
                subtitleTranslationKey='product.show.product.form.field.countryOfOrigin.help'
            />
            <StyledReactSelect
                isClearable
                placeholder={<FormattedMessage id='product.show.product.form.field.countryOfOrigin.placeholder' />}
                name={'countryOfOrigin'}
                value={selectedOption}
                options={countryOptions}
                onChange={onChange}
            />
        </>
    );
}

export default CountryOfOriginField;
